import React,{useState} from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../../hooks/usesAuth";
import AuthAPI from "../../../Services/auth/authAPI";
import StationHeader from "../headers/Station_header";
import StationSidebar from "../sidebars/StationSidebar";

export const StationLayout = ({ allowedRoles }) => {

    const { auth } = useAuth();
    const location = useLocation();


    return (AuthAPI.getUserRoles() ===
        allowedRoles[0]
    ) ? (
        <>
            <StationHeader />
            <StationSidebar />
            <main id="main" className="main">
                <Outlet />
            </main>

        </>
    ) : (
        <Navigate to="/login" state={{ from: location }} replace />
    );
};

export default StationLayout;
